/**
 * Centralized form type constants.
 *
 * Legacy forms use the pages -> components[] schema and are served by form-service (Node.js).
 * Dynamic forms use the flat fields[] schema and are served by integrations-service (Java).
 *
 * Use these helpers instead of inline type checks to make the distinction explicit.
 */

/** Legacy form component types (pages -> components[] schema). */
export const LEGACY_FORM_TYPES = ['form', 'sequential_form', 'form_section'];

/** Dynamic form component types (flat fields[] schema). */
export const DYNAMIC_FORM_TYPES = ['dynamic_form', 'dynamic_review_task'];

/** All form component types (legacy + dynamic). */
export const ALL_FORM_TYPES = [...LEGACY_FORM_TYPES, ...DYNAMIC_FORM_TYPES];

export const isLegacyForm = type => LEGACY_FORM_TYPES.includes(type);
export const isDynamicForm = type => DYNAMIC_FORM_TYPES.includes(type);
export const isAnyForm = type => ALL_FORM_TYPES.includes(type);
